import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {


  finalarray: any = []
  constructor(
    private adminApi: AdminService
  ) { }

terms:any;

  ngOnInit(): void {
    this.getTermsAndConditions()
  }

  getTermsAndConditions() {
      this.adminApi.getTerms().subscribe(data => {
        this.terms = data.description;

      });
  }




}
